// Copy for /book-a-call (EN) and /sk/book-a-call (SK).
const en = {
  seoTitle: 'Book Your Free Intro Call | Stratodata',
  seoDescription: 'Grab a slot on our calendar for a free intro call — 20 minutes to walk through your data and where Stratodata fits.',
  eyebrow: 'Free intro call',
  title: 'Pick a time that works for you',
  subtitle: '20 minutes, no slides — just your numbers and where Stratodata fits.',
  calendarTitle: 'Pick your slot',
  calendarFrameTitle: 'Book a slot on our calendar',
  messagePrompt: 'Prefer to just send us a message instead?',
  messageLink: 'Tell us more',
};

const sk: typeof en = {
  seoTitle: 'Rezervujte si úvodný hovor zdarma | Stratodata',
  seoDescription: 'Vyberte si termín v našom kalendári a rezervujte si úvodný hovor zdarma. Za 20 minút prejdeme vaše dáta a to, ako vám Stratodata môže pomôcť.',
  eyebrow: 'Úvodný hovor zdarma',
  title: 'Vyberte si čas, ktorý vám vyhovuje',
  subtitle: '20 minút bez slajdov. Len vaše čísla a to, ako vám Stratodata môže pomôcť.',
  calendarTitle: 'Vyberte si termín',
  calendarFrameTitle: 'Rezervácia termínu v našom kalendári',
  messagePrompt: 'Radšej nám chcete len napísať?',
  messageLink: 'Napíšte nám',
};

export const bookACallCopy = { en, sk };
